import gql from 'graphql-tag';
import { query } from '../../client';
export const MEMBERSHIPS_QUERY = gql `
  query MembershipsQuery($userId: String!, $status: String!) {
    memberships(userId: $userId, status: $status) @rest(
        type: "MembershipResult",
        path: "admin/memberships?filter[userId]={args.userId}&page[offset]=0&page[limit]=10&filter[status]={args.status}&include=subscription"
    ) {
      meta {
        total  
      }
      data {
        id
        name
        userId
        orderId
        inventoryId
        skuCode
        price
        currency
        origin
        effectiveAt
        status
        expireAt
        programCode
        tier
        level
        createdAt
        updatedAt
        isDeleted
        subscription {
          status
          canceledAt
          context {
            inventoryId
            tier
          }
          createdAt
          id
          isDeleted
          paymentMethodId
          renewalAt
          targetId
          type
          updatedAt
          userId
        }
      }
    }
  }
`;
// Query membership from OMNI.
export function getMemberships(userId, status = 'active') {
    return query({
        query: MEMBERSHIPS_QUERY,
        variables: { userId, status },
    });
}
export default getMemberships;
